import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { RootState } from '../store/rootReducer';

type LanguageCode = 'ko' | 'en' | 'es';

interface BlockLanguageConfig {
  [blockName: string]: LanguageCode;
}

/**
 * 특정 블록에서 특정 언어로 강제 설정하는 커스텀 훅
 * 기본: 한국어 ('ko')
 *
 * @example
 * useBlockLanguage({ fellin: 'en' });
 *
 * @example
 * useBlockLanguage({
 *   fellin: 'en',
 *   someBlock: 'ko',
 *   anotherBlock: 'es'
 * });
 */
export const useBlockLanguage = (config: BlockLanguageConfig) => {
  const { i18n } = useTranslation();
  const block = useSelector((state: RootState) => state.block.block);
  const location = useLocation();

  useEffect(() => {
    const currentSubFolder = block?.subFolder;

    if (!currentSubFolder) return;

    const targetLanguage = config[currentSubFolder];

    if (targetLanguage && i18n.language !== targetLanguage) {
      i18n.changeLanguage(targetLanguage);
    }
  }, [block?.subFolder, location.pathname, i18n, config]);
};
